import { createUseStyles } from '@glu/theming';

const styles = {
  toggle: {
    position: 'relative',
    '& button': {
      background: 'none',
      border: 'none'
    }
  }
};

export default createUseStyles(styles);
